module.exports = __webpack_public_path__ + "media/images/flags/PW-0fad227dbed95ab83f32c31f1eec2014.svg";